import SocialLinks from "../components/social-links";
import { Badge } from "../components/ui/badge";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "../components/ui/card";
import { usePageMeta } from "../lib/use-page-meta";

const domains = [
  {
    name: "pishang.my",
    description:
      "In Malaysian youth slang, “pishang” means boring. So this is either the worst name for a fun brand or the perfect home for a website about doing absolutely nothing. Memorable either way.",
  },
  {
    name: "kelaut.my",
    description:
      "Malay for “to the sea”. Say it out loud and it can also sound like “cloud”, which makes it work for travel, fishing, boats, or cloud computing. Sea or sky, your call.",
  },
];

function Domains() {
  usePageMeta({
    title: "Domains for sale",
    description:
      "pishang.my and kelaut.my are available for sale. Make an offer and let's negotiate.",
    path: "/domains",
  });

  return (
    <div className="container py-14 md:py-20">
      <div className="max-w-2xl">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">
          Domain shelf
        </p>
        <h1 className="mt-2 font-serif text-4xl font-semibold tracking-tight sm:text-5xl">
          Two domains looking for a good home
        </h1>
        <p className="mt-4 text-lg leading-8 text-muted-foreground">
          I buy domain names the way other people buy houseplants: with optimism and no
          follow-up plan. These two are ready for a new owner.
        </p>
      </div>

      <div className="mt-10 grid gap-5 sm:grid-cols-2">
        {domains.map((domain) => (
          <Card key={domain.name} className="flex flex-col">
            <CardHeader>
              <div className="flex flex-wrap items-center justify-between gap-3">
                <CardTitle className="font-serif text-2xl">{domain.name}</CardTitle>
                <Badge>For sale</Badge>
              </div>
            </CardHeader>
            <CardContent className="flex-1">
              <p className="text-sm leading-6 text-muted-foreground">
                {domain.description}
              </p>
            </CardContent>
            <CardFooter>
              <a
                href="#offer"
                className="text-sm font-medium text-primary underline-offset-4 hover:underline"
              >
                Make an offer
              </a>
            </CardFooter>
          </Card>
        ))}
      </div>

      <section
        id="offer"
        className="mx-auto mt-14 max-w-3xl scroll-mt-24 rounded-2xl border bg-secondary/50 p-8"
      >
        <h2 className="font-serif text-3xl font-semibold tracking-tight">
          Make an offer
        </h2>
        <p className="mt-3 leading-7 text-muted-foreground">
          There is no fixed price. Send me a number and I will say yes, counter, or
          politely pretend I did not see it. Negotiation is expected; lowball offers will
          be considered and then gently laughed at.
        </p>
        <p className="mt-4 leading-7 text-muted-foreground">
          The quickest way to reach me is a message on Threads or X. GitHub works too, but
          a domain offer in an issue tracker is a little weird.
        </p>
        <SocialLinks className="mt-5" />
        <p className="mt-6 text-xs leading-5 text-muted-foreground">
          Domains are sold as-is. No website, hosting, or buried treasure is included.
          Transfer happens through the registrar. Payment in money; I am not accepting
          exposure or a shoutout. Serious offers only — memes accepted as supporting
          documents.
        </p>
      </section>
    </div>
  );
}

export default Domains;
